<form class="row g-2" novalidate [formGroup]="ProcedureVehicleForm" (ngSubmit)="next()">
    <div class="col-sm-8">
        <!--<input class="form-control" id="vehicleId" type="text" formControlName="vehicleId">-->
        <label class="col-12 form-label m-0" for="insurancePolicy">Seguro póliza <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="insurancePolicy" type="text" formControlName="insurancePolicy">
        </div>
    </div>
    <!-- initialPayment -->
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="insuranceInitialPayment">Pago inicial</label>
        <div class="col-12 input-group"><span class="input-group-text">$</span>
            <input class="form-control" type="text" id="insuranceInitialPayment" aria-label="($MXN)" formControlName="insuranceInitialPayment">
            <span class="input-group-text">MXN</span>
        </div>
    </div>
    <!-- monthlyPayment -->
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="insuranceMonthlyPayment">Pago mensual</label>
        <div class="col-12 input-group"><span class="input-group-text">$</span>
            <input class="form-control" type="text" id="insuranceMonthlyPayment" aria-label="($MXN)" formControlName="insuranceMonthlyPayment">
            <span class="input-group-text">MXN</span>
        </div>
    </div>
    <!-- year -->
    <div class="col-sm-5">
        <label class="col-12 form-label m-0" for="insuranceValidity">Seguro vigencia <span class="txt-danger"> *</span></label>
        <div class="col-12 input-group">
            <input class="datepicker-here form-control digits" placeholder="yyyy-mm-dd" id="insuranceValidity"
                   name="insuranceValidity" formControlName="insuranceValidity" ngbDatepicker #dp="ngbDatepicker"
                   (click)="dp.toggle()">
        </div>
    </div>
    <!-- registeredCityId -->
    <div class="col-sm-7">
        <label class="col-12 form-label m-0" for="registeredCityId">Ciudad Emplacado<span class="txt-danger"> *</span></label>
        <select class="col-12 form-select" id="registeredCityId" required formControlName="registeredCityId">
            <option [ngValue]="null" disabled selected>Ciudad</option>
            <option *ngFor="let city of citiesList" [value]="city.id">{{ city.value }}</option>
        </select>
    </div>
    <!-- km Mtto. -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="verificationFolio">Verificación folio <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="verificationFolio" type="text" formControlName="verificationFolio">
        </div>
    </div>
    <!-- color -->
    <div class="col-sm-8">
        <label class="col-12 form-label m-0" for="verificationExpirationDate">Verificación fecha vencimiento <span class="txt-danger"> *</span></label>
        <div class="col-12 input-group">
            <input class="datepicker-here form-control digits" placeholder="yyyy-mm-dd" id="verificationExpirationDate"
                   name="verificationExpirationDate" formControlName="verificationExpirationDate" ngbDatepicker #dp2="ngbDatepicker"
                   (click)="dp2.toggle()">
        </div>
    </div>
    <!-- gps -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="voluntaryVerificationFolio">Verificación folio voluntario <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="voluntaryVerificationFolio" type="text" formControlName="voluntaryVerificationFolio">
        </div>
    </div>

    <!-- tag fuel -->
    <div class="col-sm-8">
        <label class="col-12 form-label m-0" for="voluntaryVerificationValidity">Verificación fecha vencimiento voluntario <span class="txt-danger"> *</span></label>
        <div class="col-12 input-group">
            <input class="datepicker-here form-control digits" placeholder="yyyy-mm-dd" id="voluntaryVerificationValidity"
                   name="voluntaryVerificationValidity" formControlName="voluntaryVerificationValidity" ngbDatepicker #dp3="ngbDatepicker"
                   (click)="dp3.toggle()">
        </div>
    </div>
    <div class="product-buttons mb-4">
        <button class="btn" type="submit">
            <div class="d-flex align-items-center gap-sm-2 gap-1">Guardar y continuar
                <app-common-svg-icons [icons]="'front-arrow'"></app-common-svg-icons>
            </div>
        </button>
    </div>
</form>